import React from 'react';
import IRCTVDonationCard from "./IRCTVDonationCard";
import ImageGallerarabicacademy from '../components/ImageGallerarabicacademy';
import { useStats } from '../hooks/useStats';

const IRCTV = () => {
  const { stats, loading } = useStats();

  // Format number to Indian numbering system
  const formatNumber = (num) => {
    if (!num) return '0';
    
    // For lakhs and crores
    if (num >= 10000000) {
      return `${(num / 10000000).toFixed(1)} Crore`;
    } else if (num >= 100000) {
      return `${(num / 100000).toFixed(1)} Lakh`;
    }
    
    return num.toLocaleString('en-IN');
  };

  // Format for millions and billions
  const formatInternational = (num) => {
    if (!num) return '0';
    
    if (num >= 1000000000) {
      return `${(num / 1000000000).toFixed(1)} Billion`;
    } else if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)} Million`;
    }
    
    return num.toLocaleString('en-IN');
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button 
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <ImageGallerarabicacademy />

          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC TV</h3>
            </div>
            <div className="activity-content">
              <p>
                IRC TV is a YouTube channel www.YouTube.com/IRCTV with over{' '}
                <strong>
                  {stats ? `${formatInternational(stats.subscribers)} (${formatNumber(stats.subscribers)}) subscribers` : '4.2 million (42 Lakh) subscribers'}
                </strong>{' '}
                and{' '}
                <strong>
                  {stats ? `${formatInternational(stats.views)} (${formatNumber(stats.views)}) views` : '1.1 Billion (110 Crore) views'}
                </strong>{' '}
                (as on {formatDate(stats?.tv_updated_date)}) and counting, IRC TV is a popular choice amongst Urdu speaking global audience spread across 50 countries, Alhamdulillaah.
              </p>
              <p>IRC TV Logo & Word are registered trademarks of IRC TV, registered under the Trade Marks Act 1999, with registration number 6135853 & 6136275</p>
            </div>
            <IRCTVDonationCard />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCTV;






















// import React from 'react';
// import IRCTVDonationCard from "./IRCTVDonationCard";
// import ImageGallerarabicacademy from '../components/ImageGallerarabicacademy';


// const IRCTV = () => {
//   return (
//     <>
//       <div className="about-us-container">

//         {/* Detailed Activities Section */}
//         <section className="activities-details">
//            <button 
//           onClick={() => window.history.back()}
//           style={{
//             marginBottom: '10px',
//             padding: '8px 10px',
//             backgroundColor: '#255fe8',
//             color: 'white',
//             border: 'none',
//             borderRadius: '5px',
//             cursor: 'pointer',
//             fontSize: '16px',
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           ← Back to All Activities
//         </button>
//           <ImageGallerarabicacademy />

//           {/* IRC TV */}
//           <div className="activity-card">
//             <div className="activity-header">

//               <h3>IRC TV</h3>
//             </div>
//             <div className="activity-content">
//               <p>IRC TV is a YouTube channel www.YouTube.com/IRCTV with over 4.2 million (42 Lakh) subscribers and 1.1 Billion (110 Crore) views (as on 31-Jan-2025) and counting, IRC TV is a popular choice amongst Urdu speaking global audience spread across 50 countries, Alhamdulillaah. Apart from featuring previous episodes of Islamic lectures by Adv. Faiz Syed, the founder of IRC, IRC TV also premiers live programs hosted by IRC, relating to Islamic events and contemporary/social debates, in the light of Islam.</p>
//               <p>IRC TV Logo & Word are registered trademarks of IRC TV, registered under the Trade Marks Act 1999, with registration number 6135853 & 6136275</p>
//             </div>
//           <IRCTVDonationCard />

//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default IRCTV;